import React from "react";
import { Tooltip } from "reactstrap";

import _ReactOBaseComponent from "../../_L0_components/_ReactOBaseComponent";

class ReactOTooltip extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      opened: false,
    };
    super(props, initState);
    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({
      opened: !this.state.opened,
    });
  }

  /////////////////////////
  //	Lifecycle methods
  //

  onComponentDidMount() {}

  onComponentWillUnmount() {}

  onGetChildContext() {
    return {};
  }

  onRender() {
    return (
      <Tooltip
        className={this.props.className}
        autohide={this.props.autohide}
        delay={this.props.delay || { hide: 0 }}
        placement={this.props.placement || "auto"}
        isOpen={
          this.props.keepOpen && document.querySelector("#" + this.props.target)
            ? true
            : this.state.opened
        }
        target={this.props.target}
        toggle={this.toggle}
        innerClassName={
          this.props.light && !this.props.system
            ? "light-tooltip"
            : this.props.system
            ? "system-tooltip"
            : ""
        }
        boundariesElement={this.props.boundariesElement}
        modifiers={
          this.props.keepOpen
            ? {
                hide: { enabled: false },
                flip: { enabled: false },
                preventOverflow: { enabled: false },
              }
            : {}
        }
        container={this.props.container}
      >
        <div>{this.props.text}</div>
      </Tooltip>
    );
  }
}

export default ReactOTooltip;
